import { useEffect, useState } from 'react'

import AUTH_TOKEN from '../constants/authToken'
import BASE_API from '../constants/baseApi'

/* Catálogos que os formulários de cadastro precisam para montar os selects:
   especialidades, planos de saúde, clínicas e as constantes da ficha de saúde
   (tipo sanguíneo, etnia, alimentação e afins).

   Ficam num hook só porque as três telas precisam quase dos mesmos, e porque
   assim a tela não abre com o select vazio enquanto a requisição vai e volta —
   o formulário só é montado quando `carregando` termina.

   Falha de rede não derruba o cadastro: devolve lista vazia e o campo aparece
   com o aviso de "nenhum cadastrado". Melhor um select vazio do que uma tela
   branca no meio de uma edição. */

const buscar = async caminho => {
  const resposta = await fetch(`${BASE_API}${caminho}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}` }
  })
  if (!resposta.ok) throw new Error(`Falha em ${caminho}`)
  return resposta.json()
}

/** A API pagina algumas listas ({results, count}) e devolve outras cruas. */
const comoLista = dados => {
  if (Array.isArray(dados)) return dados
  if (dados && Array.isArray(dados.results)) return dados.results
  return []
}

const VAZIO = {
  especialidades: [],
  planos: [],
  clinicas: [],
  constantes: {}
}

export default function useCatalogos({ constantes = false, clinicas = false } = {}) {
  const [dados, setDados] = useState(VAZIO)
  const [carregando, setCarregando] = useState(true)

  useEffect(() => {
    let cancelado = false

    const carregar = async () => {
      const pedidos = [
        buscar('/get-all-specialties/').catch(() => []),
        buscar('/get-all-health-insurance/').catch(() => []),
        clinicas ? buscar('/companies/').catch(() => []) : Promise.resolve([]),
        constantes ? buscar('/get-constants/').catch(() => ({})) : Promise.resolve({})
      ]

      const [esp, pl, cl, cs] = await Promise.all(pedidos)
      if (cancelado) return

      setDados({
        especialidades: comoLista(esp),
        planos: comoLista(pl),
        clinicas: comoLista(cl),
        constantes: cs || {}
      })
      setCarregando(false)
    }

    carregar()
    return () => { cancelado = true }
  }, [constantes, clinicas])

  return { ...dados, carregando }
}
